/**
 * @generated SignedSource<<8a2840084f4a092b410f6aa1ad796c71>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type MessageDefinitionButtonType = "confirm" | "link" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EditMessageDefinitionForm_MessageDefinitionFragment$data = {
  readonly buttonOpt: {
    readonly link?: string;
    readonly title: string;
    readonly type: MessageDefinitionButtonType;
  } | null | undefined;
  readonly id: string;
  readonly internalTitle: string;
  readonly notificationDefinitionOpt: {
    readonly body: string;
    readonly title: string;
  } | null | undefined;
  readonly showUntilOpt: any | null | undefined;
  readonly " $fragmentType": "EditMessageDefinitionForm_MessageDefinitionFragment";
};
export type EditMessageDefinitionForm_MessageDefinitionFragment$key = {
  readonly " $data"?: EditMessageDefinitionForm_MessageDefinitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditMessageDefinitionForm_MessageDefinitionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditMessageDefinitionForm_MessageDefinitionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "buttonOpt",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "type": "MessageDefinitionLinkButton",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showUntilOpt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NotificationDefinitionType",
      "kind": "LinkedField",
      "name": "notificationDefinitionOpt",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MessageDefinition",
  "abstractKey": null
};
})();

(node as any).hash = "7dc570ebba140bbcf44fcd9b16ec787b";

export default node;
